export const Locations = {
    "horizontal-box":"horizontal-box",
     "vertical-box": "vertical-box"
}